import React from "react";

const ICON_LABEL_CLASS = "flex items-center gap-1 text-text";
const COLOR_INPUT_CLASS =
  "h-8 w-8 cursor-pointer rounded border border-border bg-transparent p-0";
const RANGE_INPUT_CLASS = "w-24 accent-[#ff9f43]";
const ACTION_BUTTON_CLASS =
  "flex h-8 w-8 items-center justify-center rounded-md text-text hover:bg-surface-muted focus:outline-none focus:ring-2 focus:ring-primary";
const ACTIVE_TOGGLE_BUTTON_CLASS = "border-primary bg-info-surface text-primary";
const INACTIVE_TOGGLE_BUTTON_CLASS =
  "border-transparent text-text hover:bg-surface-muted";
const TOGGLE_BUTTON_CLASS =
  "flex h-8 w-8 items-center justify-center rounded-md border-2 focus:outline-none focus:ring-2 focus:ring-primary";
const INPUT_NUMBER_CLASS =
  "h-8 w-14 rounded border border-border bg-surface-muted px-2 text-sm text-text";
const SELECT_CLASS =
  "h-8 rounded border border-border bg-surface-muted px-2 text-sm text-text";

export const createStyleChange = ({ key, onStyleChange, value }) => {
  onStyleChange({ [key]: value });
};

export const StyleColorInput = ({ Icon, label, name, onStyleChange, value }) => (
  <label className={ICON_LABEL_CLASS} title={label}>
    <Icon className="h-4 w-4" fontSize="small" />
    <input
      aria-label={label}
      className={COLOR_INPUT_CLASS}
      onChange={(event) =>
        createStyleChange({
          key: name,
          onStyleChange,
          value: event.target.value,
        })
      }
      type="color"
      value={value}
    />
  </label>
);

export const StyleNumberInput = ({ Icon, label, name, onStyleChange, value }) => (
  <label className={ICON_LABEL_CLASS} title={label}>
    <Icon className="h-4 w-4" fontSize="small" />
    <input
      aria-label={label}
      className={name === "strokeWidth" ? RANGE_INPUT_CLASS : INPUT_NUMBER_CLASS}
      max={name === "strokeWidth" ? 12 : 48}
      min={name === "strokeWidth" ? 1 : 10}
      onChange={(event) =>
        createStyleChange({
          key: name,
          onStyleChange,
          value: Number(event.target.value),
        })
      }
      type={name === "strokeWidth" ? "range" : "number"}
      value={value}
    />
  </label>
);

export const StyleSelect = ({ label, name, onChange, options, value }) => (
  <select
    aria-label={label}
    className={SELECT_CLASS}
    name={name}
    onChange={(event) => onChange(event.target.value)}
    title={label}
    value={value}
  >
    {options.map(({ optionLabel, optionValue }) => (
      <option key={optionValue} value={optionValue}>
        {optionLabel}
      </option>
    ))}
  </select>
);

export const ActionButton = ({ Icon, label, onClick }) => (
  <button
    aria-label={label}
    className={ACTION_BUTTON_CLASS}
    onClick={onClick}
    title={label}
    type="button"
  >
    <Icon className="h-4 w-4" fontSize="small" />
  </button>
);

export const ToggleButton = ({ Icon, isPressed, label, onClick }) => (
  <button
    aria-label={label}
    aria-pressed={isPressed}
    className={[
      TOGGLE_BUTTON_CLASS,
      isPressed ? ACTIVE_TOGGLE_BUTTON_CLASS : INACTIVE_TOGGLE_BUTTON_CLASS,
    ].join(" ")}
    onClick={onClick}
    title={label}
    type="button"
  >
    <Icon className="h-4 w-4" fontSize="small" />
  </button>
);
